import React from 'react';

const InvalidMessage = () => {
    return (
        <div>
            <h2>The link you have entered is not found.</h2>
        </div>
    );
};

export default InvalidMessage;